// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './MultiSelectDropdown.scss'

import { useTranslation } from "react-i18next";

export default function MultiSelectDropdown({ selectedOptions, options, onChange, propertyFieldStyle=false }) {
  const { i18n, t } = useTranslation();
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);
  
    const toggleDropdown = () => setIsOpen(!isOpen);
  
    const handleOptionChange = (option) => {
      const currentIndex = selectedOptions.indexOf(option);
      const newSelectedOptions = [...selectedOptions];
  
      if (currentIndex === -1) {
        newSelectedOptions.push(option);
      } else {
        newSelectedOptions.splice(currentIndex, 1);
      }
  
      onChange(newSelectedOptions); // Propagate changes up to the parent component
    };

  // Effect for handling clicks outside the dropdown
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close the dropdown if the click is outside
      }
    };

    // Add event listener when the component is mounted
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const title = selectedOptions.length === 0 ? t("multi_select_title_empty") : `${selectedOptions.length} ${t("multi_select_title")}`
  
  return (
    <div className="multi-select-dropdown" ref={dropdownRef}>
      <button onClick={toggleDropdown} className={`dropbtn ${propertyFieldStyle&&"dropbt-property-field-style"}`}>{title}</button>
      {isOpen && (
        <ul 
          className={`dropdown-content ${propertyFieldStyle ? "dropdown-content-property-field-style" : ""}`}
          style={{ display: "flex" }} // Explicitly set display to flex
        >
          {Object.keys(options).map((labelId, index) => (
            <li key={index}>
              <label>
                <input
                  type="checkbox"
                  checked={selectedOptions.includes(labelId)}
                  onChange={() => handleOptionChange(labelId)}
                />
                {options[labelId]}
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}